import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon22: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M10 0a9.99 9.99 0 0 1 3.592.664c.257.1.386.389.287.647a.502.502 0 0 1-.647.287A8.962 8.962 0 0 0 10 1a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9.003 9.003 0 0 0 8.318-5.556.5.5 0 0 1 .924.383A10.002 10.002 0 0 1 10 20C4.477 20 0 15.523 0 10S4.477 0 10 0Zm9.137 2.161a.5.5 0 1 1 .726.688l-9.5 10.004a.501.501 0 0 1-.74-.016L6.134 8.829a.501.501 0 0 1 .754-.657l3.128 3.593 9.121-9.604Z"
      />
    </Svg>
  )
}
